import { render } from "./electricityStat.vue?vue&type=template&id=10ae7d2a&scoped=true"
import script from "./electricityStat.vue?vue&type=script&lang=js"
export * from "./electricityStat.vue?vue&type=script&lang=js"

import "./electricityStat.vue?vue&type=style&index=0&id=10ae7d2a&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ae7d2a"]])

export default __exports__